import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import CenteredColumns from "./CenteredColumns";
import Avatar from "./Avatar";
import "./TeamBiosSection.scss";

function TeamBiosSection(props) {
  const items = [
    {
      avatar: "edz.svg",
      name: "Edward Zyszkowski",
      role: "Co-founder & CEO",
      bio: "A technology/business innovator, entrepreneur and investor who has created industry-defining technologies and successful software companies, Edward orchestrated valuable exits to Boeing, IBM (Watson), Yahoo and Google, as well as lucrative P/E deals: Tiburon, Syncplicity and Digital Fuel.",
    },
    {
      avatar: "igal.svg",
      name: "Igal Vainer",
      role: "Co-founder & CTO",
      bio: "An expert in software architecture and enterprise engineering management, Igal has led teams to re-architect major equities and commodities trading systems, global file sharing platforms as well as working with startups to design and deliver new products.",
    },
    {
      avatar: "lori.svg",
      name: "Lori Fena",
      role: "Co-founder & VP Business Development",
      bio: "A thought leader & author on digital privacy, individual rights and licensing, Lori founded and exited a tech licensing company (Stream Intl). She then founded TRUSTe, served as Exec. Director & Chair of the Electronic Frontier Foundation and was an investor and board member of Critical Path (CPTH).",
    },
  ];

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <CenteredColumns>
          {items.map((item, index) => (
            <div
              className="column is-half-tablet is-one-third-desktop is-flex"
              key={index}
            >
              <div className="TeamBiosSection__card card is-flex">
                <div className="TeamBiosSection__card-content card-content is-flex has-text-centered">
                  <div className="TeamBiosSection__avatar-wrapper">
                    <Avatar image={item.avatar} size={64} alt={item.name} />
                  </div>
                  <div className="TeamBiosSection__details">
                    <p className="is-size-5">{item.name}</p>
                    <p className="is-size-7 is-uppercase has-text-weight-semibold">
                      {item.role}
                    </p>
                    <p className="TeamBiosSection__bio">{item.bio}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </CenteredColumns>
      </div>
    </Section>
  );
}

export default TeamBiosSection;
